
export default {
  name: 'SalaryGuide',

  props: {
    images: {
      type: Boolean,
    },
    squeeze: {
      type: String,
      default: 'false'
    },
  },
  data(){
    return{
      isSuccessful: {
        default: false,
        type: Boolean
      }
    }
  },
  methods: {
    showSuccess(){
      // this.$emit('success')
      console.log('success emitted');
      this.isSuccessful = true
    }
  }
}
